<template>
      <div style="margin: 0; position: relative">
        <div><!--Loader--></div>
        
   <div style="margin: 0;">


          <vs-card style="padding: 0 !important; margin: 0 !important">

               <vs-row style="background: linear-gradient(118deg, rgba(var(--vs-primary),1), rgba(var(--vs-primary),0.7));
              padding: 10px 12px !important;
              margin: 0 important;
              display: flex;
              align-items: center; ">
          <vs-col class="w-1/2">
            <h4 style="margin-left: 14%; color: white; padding: 0">Discharge</h4>
          </vs-col>
          <vs-col class="w-1/2">
            <div style="margin-left: 90%; cursor: pointer">
              <feather-icon
                icon="XIcon"
                style="color: white"
                class="custom-class"
                title="close"
                 @click="closeDischarge"
              ></feather-icon>
            </div>
          </vs-col>
        </vs-row>
         <vs-divider style="margin-top: 0"></vs-divider>


          <div style="padding-left: 4%; padding-right: 4%">
         <vs-row>

  
  <!-- Left column -->
<vs-col vs-lg="8" vs-sm="12" class="pl-2">

  <vs-row class="mb-3" style="margin-top: 2%">

    <!-- IP No Label -->
    <vs-col vs-lg="2" vs-sm="4" class="topPad">
      <span class="inputStyles">IP No</span>
    </vs-col>

    <!-- IP No Input -->
    <vs-col vs-lg="3" vs-sm="8">
      <vs-input v-model="ipData.ipNo" style="width: 100%"  readonly/>
    </vs-col>

    <!-- IP Date Label -->
    <vs-col vs-lg="2" vs-sm="4" class="topPad">
      <span class="inputStyles">IP Date</span>
    </vs-col>

    <!-- IP Date Input -->
    <vs-col vs-lg="3" vs-sm="8">
      <vs-input
        v-model="ipData.ipDate"
        type="date"
        style="width: 100%"
      />
    </vs-col>

  </vs-row>


   <vs-row class="mb-3">
    <vs-col vs-lg="2" vs-sm="4" class="topPad">
      <span class="inputStyles">Discharge Date</span>
    </vs-col>
    <vs-col vs-lg="3" vs-sm="8">
      <vs-input v-model="dischargeDate" type="date" :value="todayDate" style="width: 100%" />
    </vs-col>

    <vs-col vs-lg="2" vs-sm="4" class="topPad">
      <span class="inputStyles">Discharge Time</span>
    </vs-col>
    <vs-col vs-lg="3" vs-sm="8">
      <vs-input v-model="dischargeTime" type="time"  style="width: 100%" />
    </vs-col>
  </vs-row>

<vs-row class="mb-3">
    <vs-col vs-lg="2" vs-sm="4" class="topPad">
      <span class="inputStyles">Room No</span>
    </vs-col>
    <vs-col vs-lg="3" vs-sm="8">
      <vs-input v-model="ipData.roomNo" style="width: 100%"  readonly/>
    </vs-col>

    <vs-col vs-lg="2" vs-sm="4" class="topPad">
      <span class="inputStyles">Status</span>
    </vs-col>
    <vs-col vs-lg="3" vs-sm="8">
      <vs-input v-model="status" style="width: 100%"  readonly/>
    </vs-col>
  </vs-row>
</vs-col>


  <!-- Right column -->
 <vs-col vs-lg="4" vs-sm="12">
  <div
    style="
      border: 2px solid #ddd;
      border-radius: 12px;
      padding: 20px 20px;
      background-color: #eaeff3;
      font-size: 12px;
    "
  >
    <!-- Patient ID -->
    <div style="display: flex; margin-bottom: 10px;">
      <div style="width: 80px; font-weight: bold;">Patient ID</div>
      <div style="width: 10px;">:</div>
      <div>{{this.patientId}}</div>
    </div>

    <!-- Name -->
    <div style="display: flex; margin-bottom: 10px;">
      <div style="width: 80px; font-weight: bold;">Name</div>
      <div style="width: 10px;">:</div>
      <div>{{ patientDetails.name }}</div>
    </div>

    <!-- Age and Sex on same row -->
    <div style="display: flex; margin-bottom: 10px;">
      <div style="width: 80px; font-weight: bold;">Age</div>
      <div style="width: 10px;">:</div>
      <div style="margin-right: 20px;">{{ patientDetails.age }}</div>
      
      <div style="width: 40px; font-weight: bold;">Sex</div>
      <div style="width: 10px;">:</div>
      <div>{{ patientDetails.gender }}</div>
    </div>

    <!-- Doctor -->
    <div style="display: flex; margin-bottom: 10px;">
      <div style="width: 80px; font-weight: bold;">Doctor</div>
      <div style="width: 10px;">:</div>
      <div>{{ ipData.doctorName }}</div>
    </div>
  </div>
</vs-col>



</vs-row>



<vs-row>
  <vs-col vs-lg="12" vs-sm="12">
    <!-- Wrapper for spacing -->
    
      <vs-tabs  type="line">
        <vs-tab label="Finance" name="finance">
  <vs-card style="padding: 20px; min-height: 150px;">

    <h5 style="text-align:center; margin-bottom:20px;">IP Due Bills</h5>

    <vs-row class="mt-2">
      <vs-col vs-lg="11" vs-sm="12">

        <table hoverFlat class="w-full ml-auto mt-4"
               style="padding-left:4%; padding-right:4%; padding-bottom:5%">

          <thead>
            <tr>
              <th style="text-align:center">SrNo</th>
              <th style="text-align:center">Type</th>
              <th style="text-align:center">Bill Date</th>
              <th style="text-align:center">Bill No</th>
              <th style="text-align:center">Due Amount</th>
              <th style="text-align:center">Collected Amount</th>
              <th style="text-align:center">Balance Amount</th>
              <th style="text-align:center">Collect</th>
            </tr>
          </thead>
          <tbody v-if="isFinanceLoading">
  <tr>
    <td colspan="8" style="text-align:center; padding:20px">
      Loading bill dues...
    </td>
  </tr>
</tbody>
          <tbody v-else-if="BillDue.length == 0">
            <tr>
              <td colspan="8">
                <vs-alert active="true" color="warning" style="text-align:center">
                  <span>No Bill Dues</span>
                </vs-alert>
              </td>
            </tr>
          </tbody>

          <tbody v-else>
            <tr hoverFlat :key="index"
                v-for="(due, index) in BillDue"
                @dblclick="navigateToBill(due.billId)">

              <td style="text-align:center">{{ index + 1 }}</td>

              <td><vs-input readonly class="w-full configclass" v-model="due.typeName"/></td>

              <td><vs-input readonly class="w-full configclass" :value="formatDate(due.billDate)"/></td>

              <td><vs-input readonly class="w-full configclass" v-model="due.billId"/></td>

              <td><vs-input readonly class="w-full configclass" v-model="due.dueAmount"/></td>

              <td>
                <vs-input  
                          readonly
                          class="w-full configclass"
                          v-model="due.collectedAmount"/>
              </td>

              <td><vs-input readonly class="w-full configclass" v-model="due.balanceAmount"/></td>

              <td style="text-align:center">
                <vs-checkbox v-model="due.collectedFlag" @change="toggleCollection(due)"/>
              </td>

            </tr>
          </tbody>

          <tfoot>
            <tr>
              <th style="text-align:right;" colspan="7">Total Due</th>
              <td><vs-input readonly class="w-full configclass" v-model="receiptData.totalAmount"/></td>
            </tr>

            <tr>
              <th style="text-align:right;" colspan="7">Receipt Amount</th>
              <td><vs-input readonly class="w-full configclass"
                            v-model="receiptData.receiptAmount" /></td>
            </tr>

            <tr>
              <th style="text-align:right;" colspan="7">Payment Mode</th>
              <td>
                <vs-select  class="configclass" v-model="receiptData.paymentMode">
                  <vs-select-item v-for="(item,index) in paymentModes"
                                  :key="index"
                                  :value="item.paymentId"
                                  :text="item.paymentMode"/>
                </vs-select>
              </td>
            </tr>

            <tr>
              <th style="text-align:right;" colspan="7">Balance Amount</th>
              <td><vs-input readonly class="w-full configclass" v-model="receiptData.balanceAmount"/></td>
            </tr>

          </tfoot>

        </table>

      </vs-col>
    </vs-row> <!-- ✔ THIS WAS MISSING -->

  </vs-card>
</vs-tab>



        <!-- Discharge Details Tab -->
        <vs-tab label="Discharge Details" name="dischargeDetails">
  <vs-card style="padding: 20px; min-height: 150px;">
    
    <h5 style="text-align:center; margin-bottom:20px;">Discharge Details</h5>

    <div v-for="(field, index) in dynamicNotes" :key="index" class="mb-4">

      <label class="inputStyles">{{ field.name }}</label>

      <vs-textarea 
        v-model="field.value"
        class="w-full mt-1"
        rows="3"
      ></vs-textarea>

    </div>

  </vs-card>
</vs-tab>

      </vs-tabs>
    
  </vs-col>
</vs-row>
    <vs-row>

        <vs-card class="footer" style="padding: 10px;" >
         <div style="float:left; padding-left:10px; padding-top:6px; display:flex; align-items:center;">
  <vs-checkbox v-model="printWithBill" />

  <span style="margin-left:8px; font-size:12px; font-weight:600; color:#2c2c2c;">
    {{ printWithBill 
        ? 'Print Discharge Summary with Bill' 
        : 'Print Discharge Summary without Bill' 
    }}
  </span>
</div>

            <div class="btn-group"    style="margin-left:62%; display:flex; gap:5px; flex-wrap:wrap;">
              
       

                <vs-button style="width: 100px;"  color="success"  type="filled" @click="saveDischarge">Save</vs-button>

                <vs-button style="width: 100px;"   color="primary" @click="printDischarge"  >Print</vs-button>
                 <vs-button
  style="width: 120px;"
  color="primary"
  @click="printIpBill"
>
  Print IP Bills
</vs-button>
                <vs-button style="width: 100px;"  color="danger" type="filled"  @click="closeDischarge">Exit</vs-button>
     
     

            </div>

        </vs-card>

    </vs-row>
          </div>
          </vs-card>
    </div>
    <printDischarge 
    ref="printDis"
  style="display:none"
  :patientId="patientId"
  :patientDetails="patientDetails"
  :ipData="ipData"
  :dischargeDate="dischargeDate"
  :dischargeTime="dischargeTime"
  :dynamicNotes="dynamicNotes"
   :printWithBill="printWithBill"
     :bills="bills"
></printDischarge>
<printIpBill
  ref="printIpBill"
  style="display:none"
  :patientId="patientId"
  :patientDetails="patientDetails"
  :ipData="ipData"
   :dischargeDate="dischargeDate"
   :dischargeTime="dischargeTime"
  :bills="bills"
></printIpBill>
      </div>
    


</template>
<script>
import printDischarge  from '../components/printDischarge';
import printIpBill from '../components/printIpBill';
import pdfMake from "pdfmake/build/pdfmake";
 import pdfFonts from "pdfmake/build/vfs_fonts";
pdfMake.vfs = pdfFonts.vfs;
export default {
   components:{
        printDischarge,
        printIpBill,
    },
    data() {
    return {
       dischargeTime:new Date().toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit' }),
        dischargeDate: new Date().toISOString().substr(0, 10),
        activeTab: 'finance',
        status:"",
        patientId: "",
         printWithBill: false, 
         bills: [],
        
  ipData: {
      ipNo: "",
      ipDate: "",
      ipTime: "",
      doctorName: "",
      roomNo: "",
      roomCategory: ""
    },
      
     patientDetails: {
      
      name: "",
      age: "",
      gender: "",
    
      // whatever backend gives
    },
    BillDue: [],
paymentModes: [],
  readonly: false,
receiptData: {
  totalAmount: 0,
  receiptAmount: 0,
  paymentMode: 1,
  balanceAmount: 0
},
showDis:false,
dynamicNotes: [] ,
    isFinanceLoading: true,
    };
  },
  async mounted() {
this.ipData.ipNo = this.$route.query.ipNo;
  this.patientId = this.$route.query.patientId;

  await this.getpatientDetails();  // fetch patient, doctor, name, etc.
  await this.getIpDetails();       // fetch ip date, time, room, category, etc.
  
    await this.loadFinanceData();   // loads dues + payment modes
  
    await this.loadClientNotes();
    await this.loadSavedDischarge();
}
,
methods: {
  async loadFinanceData() {
    if (!this.patientId) return;
this.isFinanceLoading = true;
     await Promise.all([
    this.getPaymentMode(),
    this.getBillDues()
  ]);
  this.isFinanceLoading = false;

    
  },
   navigateToBill(billId) {
              
            this.$router.push({
                path: 'billing',
                query: {
                    patientId: this.patientId,
                    billId: billId
                }
            })
              
        },
  async getPaymentMode() {
  try {
    const response = await this.$http.post(
      "v2/getpaymentmode",
      {}, 
      {
        headers: { "Content-Type": "application/json" }
      }
    );

    this.paymentModes = response.data.data;
  } catch (error) {
    console.error("Error in getPaymentMode:", error);
  }
},

       async getBillDues() {
            var request = {
                companyId: this.$session.get('companyId'),
                patientId: this.patientId
            }

           const response= await this.$http.post(
                    "getduebills",
                    JSON.stringify(request), {
                        headers: {
                            "Content-Type": "application/json"
                        }
                    })
                    let allDues = response.data.data;

  // Filter ONLY IP dues
 this.BillDue = allDues.filter(x =>
   (x.typeName === "IP" || x.billTypeId === 2) &&
   x.refId == this.ipData.ipNo
);

               console.log("billdues of type ip******", this.BillDue)
               this.receiptData.totalAmount = 0;
                    this.BillDue.forEach(element => {
                        element.collectedFlag = false;
                        element.balanceAmount = element.dueAmount;
                        element.collectedAmount = 0;
                        this.receiptData.totalAmount += element.dueAmount;
                    });
                    this.receiptData.totalAmount = parseFloat(this.receiptData.totalAmount.toFixed(2));
                    this.receiptData.balanceAmount = this.receiptData.totalAmount;
                    console.log("receiptdata",this.receiptData)
                
        },
        async loadSavedDischarge() {
  const req = {
    companyId: this.$session.get("companyId"),
    patientId: this.patientId,
    ipId: this.ipData.ipNo 
  };

  const response = await this.$http.post("dischargeInfo", req);
 
  const saved = response.data.data || [];

  if (response.data.dischargeFlag === "Y") {

    this.status = "Discharged";

    this.dischargeDate = response.data.dischargeDate;
    this.dischargeTime = this.convertTo24(response.data.dischargeTime);

  } else {
   
   
    this.status = "Admitted";
  }
  this.dynamicNotes = this.dynamicNotes.map(field => {
    const existing = saved.find(s => s.dhmId === field.id);
    return {
      ...field,
      value: existing ? existing.value : ""  
    };
  });
},

    
  closeDischarge() {
    this.$router.push('/ipDetails');
  },
        formatDate(dateStr) {
      if (!dateStr) return "";
      const [year, month, day] = dateStr.split("-");
      return `${day}/${month}/${year}`;
    },
   async getpatientDetails() {
          try{
            
            var request = {
                companyId: this.$session.get('companyId'),
                regNo: this.patientId
            };
             const response=await this.$http.post(
                    "getpatiententry",
                    JSON.stringify(request), {
                        headers: {
                            "Content-Type": "application/json"
                        }
                    })
                
                
                   if (response.data && response.data.data) {
      const apiData = response.data.data;

     this.patientDetails = {
  name: apiData.name,
  age: apiData.age,
  gender: apiData.gender,
  phoneNo: apiData.phoneNo,
  address: apiData.address,
  
  place: apiData.place,
  city: apiData.city,
  pinCode: apiData.pinCode
};

      this.errorMessage = [];

    } else {
                this.patientDetails = {};
                this.$vs.notify({
                    title: 'Patient Not Found',
                    text: `No patient found with ID ${this.patientId}.`,
                    color: 'warning',
                    position: 'top-right'
                });
            }



                } catch(error) {
        console.error("Error fetching patient details:", error);
        this.patientDetails = {};
        this.$vs.notify({
            title: 'Error',
            text: 'Failed to fetch patient details. Please try again.',
            color: 'danger',
            position: 'top-right'
        });
    }
        },
        async getRefBills() {
  try {
    const request = {
      companyId: this.$session.get("companyId"),
      patientId: this.patientId,
       refId: this.ipData.ipNo,
      billType: "IP"
    };

    const response = await this.$http.post(
      "getRefBills",
      JSON.stringify(request),
      {
        headers: { "Content-Type": "application/json" }
      }
    );

    if (response.data && response.data.data) {
      return response.data.data;
    }

    return [];
  } catch (err) {
    console.error("Error fetching bills", err);
    return [];
  }
},

        async getIpDetails() {
  const request = {
    companyId: this.$session.get('companyId'),
    patientId: this.patientId,
    refId: this.ipData.ipNo   // coming from router query
  };

  this.readonlyFlag = this.saveFlag = true;

  const response = await this.$http.post(
    "/getIpDetails",
    JSON.stringify(request),
    {
      headers: { "Content-Type": "application/json" },
    }
  );

  const data = response.data.data;
  Object.assign(this.ipData, data.ipData);
  
  this.ipData.roomNo = data.roomData.roomNo;
 
},
// Convert "10:24 AM" → "10:24"
convertTo24(timeStr) {
  const [time, modifier] = timeStr.split(' ');
  let [hours, minutes] = time.split(':');

  if (modifier === 'PM' && hours !== '12') {
    hours = String(Number(hours) + 12);
  }
  if (modifier === 'AM' && hours === '12') {
    hours = '00';
  }

  return `${hours}:${minutes}`;
},

toggleCollection(due) {
  if (due.collectedFlag) {
    // FULL COLLECTION
    due.collectedAmount = Number(due.dueAmount);
    due.balanceAmount = 0;
  } else {
    // UNCHECK → revert back
    due.collectedAmount = 0;
    due.balanceAmount = Number(due.dueAmount);
  }

  this.recalculateTotals();
},
recalculateTotals() {
  let totalCollected = 0;

  this.BillDue.forEach(item => {
    totalCollected += Number(item.collectedAmount || 0);
  });
totalCollected = Number(totalCollected.toFixed(2));
  this.receiptData.receiptAmount = totalCollected;
  let balance = Number(this.receiptData.totalAmount) - totalCollected;
  this.receiptData.balanceAmount = Number(balance.toFixed(2));
},
async loadClientNotes() {
  const req = { companyId: this.$session.get("companyId") };

  const response = await this.$http.post("clientNotes", req);
  const notes = response.data.data;

  
  this.dynamicNotes = notes.map(n => ({
    id: n.id,
    name: n.name,
    value: ""     // EMPTY initially
  }));
},
async saveDue() {
  return new Promise((resolve, reject) => {

    const unpaid = this.BillDue.filter(x => Number(x.collectedAmount) === 0);
    const collected = this.BillDue.filter(x => Number(x.collectedAmount) > 0);
   if (collected.length > 0 && (!this.receiptData.receiptAmount || this.receiptData.receiptAmount <= 0)) {
      this.$vs.notify({
        title: "Invalid",
        text: "Please enter a valid Receipt Amount",
        color: "warning"
      });
      return reject();
    }

   

    // SHOW WARNING IF UNPAID BILLS EXIST
    if (unpaid.length > 0) {
      this.$vs.dialog({
        type: 'confirm',
        color: 'warning',
        title: 'Pending Dues',
        text: `${unpaid.length} bills are still unpaid. Do you want to continue?`,
        acceptText: 'Continue',
        cancelText: 'Cancel',

        accept: async () => {
          try {
            // Save only collected bills
            if (collected.length > 0) {
              await this.callSaveApi();
            }
              await this.getBillDues();
            this.recalculateTotals();
            resolve(); // continue discharge
          } catch (err) {
            reject(err);
          }
        },

        cancel: () => reject("User cancelled")
      });
    }
    else {
      // No unpaid → save collected bills only
    if (collected.length > 0) {
        this.callSaveApi()
          .then(async () => {

            //REFRESH BILL DUES AFTER SAVING
            await this.getBillDues();
            this.recalculateTotals();

            resolve();
          })
          .catch(reject);
      } else {
        resolve(); // nothing to save → continue
      }
    }
  });
},
async callSaveApi() {
  var request = {
    companyId: this.$session.get('companyId'),
    patientId: this.patientId,
    userId: this.$session.get('userId'),
    receiptData: this.receiptData,
    billData: this.BillDue.filter(item => item.collectedAmount > 0)
  };

  const response = await this.$http.post(
    "saveduebills",
    JSON.stringify(request),
    { headers: { "Content-Type": "application/json" } }
  );

  this.receiptData.receiptNo = response.data.data.srNo;
 
},
async saveClientNotes() {
  const details = this.dynamicNotes.map(n => ({
    id: null,        
    dhmId: n.id,       
    value: n.value    
  }));

  const req = {
    companyId: this.$session.get("companyId"),
    patientId: this.patientId,
   refId: this.ipData.ipNo  ,  
    details: details,
      dischargeDate: this.dischargeDate,   // separate field
    dischargeTime: this.dischargeTime
  };

  await this.$http.post(
    "addDischargeInfo",
    JSON.stringify(req),
    { headers: { "Content-Type": "application/json" } }
  );
},

async saveDischarge() {
  try {
    await this.saveDue();          
    await this.saveClientNotes();
    

    this.$vs.notify({
      title: "Saved Successfully",
      color: "success",
      iconPack: "feather",
      icon: "icon-check",
      position: "top-center"
    });

  } catch (error) {
    this.$vs.notify({
      title: "Saving Failed",
      text: "Please try again.",
      color: "danger",
      position: "top-center"
    });
  }
},
 async printDischarge() {
   this.bills = [];

  if (this.printWithBill) {
    console.log("Calling getRefBills API...");
    this.bills = await this.getRefBills();
    console.log("Bills from API:", this.bills);
  }
             const docDefinition = await this.$refs.printDis.buildDischargeDocDefinition(); 
     pdfMake.createPdf(docDefinition).open(); 
        },
   
async printIpBill() {
  try {
    console.log("Calling getRefBills API...");

    this.bills = await this.getRefBills();

    console.log("All IP Bills:", this.bills);

    const docDefinition =
      await this.$refs.printIpBill.buildIpBillDocDefinition();

    pdfMake.createPdf(docDefinition).open();

  } catch (error) {
    console.error("Error printing IP bills:", error);

    this.$vs.notify({
      title: "Print Failed",
      text: "Unable to print IP bills.",
      color: "danger",
      position: "top-center"
    });
  }
}

    /*onchangeCollected(index) {
            if (this.BillDue[index].collectedAmount) {
                if (this.BillDue[index].collectedAmount > this.BillDue[index].dueAmount || this.isNumeric(this.BillDue[index].collectedAmount) == false) {
                    this.BillDue[index].collectedAmount = this.BillDue[index].dueAmount;
                }
            };
            if (this.BillDue[index].collectedAmount <= 0) {
                this.BillDue[index].collectedFlag = false;
            } else {
                this.BillDue[index].collectedFlag = true;
            }
            this.updatebalanceAmount();
            this.showTotal();
        },
          showTotal() {
            this.receiptData.receiptAmount = 0;
            this.receiptData.balanceAmount = 0;
            this.BillDue.forEach((value) => {
                this.receiptData.receiptAmount = (this.receiptData.receiptAmount * 1) + (value.collectedAmount * 1);
                this.receiptData.balanceAmount += value.balanceAmount;
            });
            this.receiptData.receiptAmount = parseFloat(this.receiptData.receiptAmount.toFixed(2));
            this.receiptData.balanceAmount = parseFloat(this.receiptData.balanceAmount.toFixed(2));
        },
        onchangeFlag(index) {
            if (this.BillDue[index].collectedFlag == true) {
                this.BillDue[index].collectedAmount = this.BillDue[index].dueAmount;
            } else {
                this.BillDue[index].collectedAmount = 0;
            }
            this.updatebalanceAmount();
            this.showTotal();
        },

        updatebalanceAmount() {
            this.BillDue.forEach((value) => {
                value.balanceAmount = value.dueAmount - value.collectedAmount;
                value.balanceAmount = (value.balanceAmount).toFixed(2)*1

            });
        },*/

}
}
</script>
<style scoped>
table th {

    text-align: center;

}

table thead {

    background: #eaeff3;

}
.configclass {

    width: -webkit-fill-available;

}
</style>